const messages = {
  blog: 'Blog',
  post: 'Post',
  company: 'Company',
  information: 'Information',
  category: 'Category',
  board: 'Board',
  user: 'User',
  reader: 'Reader',
  admin: 'Admin',
  navigation: 'Navigation',
  page: 'Page',
  favorite: 'FAVORITE',
  overview: 'Overview',
  management: 'MANAGEMENT',
  file: 'CLOUD',
  account: 'ACCOUNT',
  analyse: 'ANALYSE',
  import: 'Import Posts',
  partner: 'PARTNER',
  dashboard: 'DASHBOARD',
  judge: 'JUDGE',
  seller: 'SELLER',
  editor: 'EDITOR',
  candidate: 'CANDIDATE',
};

export default messages;
